export const moveItem = (items: unknown[], from: number, to: number): unknown[] => {
  const moveResult = [...items];
  const moved = items[from];

  moveResult.splice(from, 1);
  moveResult.splice(to, 0, moved);

  return moveResult;
};
